import type {
  AllChecklistsQuery,
  ChecklistNode,
  ChecklistsType,
  CrontabSettings,
} from '@/modules/checklists'

export const transformChecklistQueryData = (data: AllChecklistsQuery) => {
  const checklistData: ChecklistNode[] = data.allChecklists.edges.map(
    edge => edge.node
  )

  return Object.assign(
    {},
    ...checklistData
      .filter(checklist => checklist.active)
      .map(checklist => {
        return {
          [checklist.id]: checklistToChecklistType(checklist),
        }
      })
  ) as ChecklistsType
}

export function checklistToChecklistType(checklist: ChecklistNode) {
  return {
    id: checklist.id,
    title: checklist.title,
    entries: Object.assign(
      {},
      ...checklist.items.map(item => {
        return { [item.id]: item }
      })
    ),
    active: checklist.active,
  }
}

export const getCrontabSettingsFromString = (s: string) => {
  const dayOfWeek = s === 'daily' ? 'mon-fri' : s === 'weekly' ? 'mon' : '*'
  const dayOfMonth = s === 'monthly' ? '0' : '*'
  return {
    minute: '0',
    hour: '3',
    dayOfWeek,
    dayOfMonth,
    monthOfYear: '*',
  } as CrontabSettings
}

export const getCrontabStringFromSettings = (crontab: string) => {
  return crontab.split(' ')[2] === 'mon-fri'
    ? 'daily'
    : crontab.split(' ')[2] === 'mon'
    ? 'weekly'
    : 'monthly'
}
